<template>
  <div v-if="officialdAnswerId != comment.id">
    <ButtonPrimary
      :small="true"
      @click="openModal()"
    >
      {{ spot.officialAnswer ? $t('spotdetail.comments_official_answer_replace') : $t('spotdetail.comments_official_answer_mark')
      }}
    </ButtonPrimary
    >
    <Modal :id="'add_official_answer_modal-'+comment.id">
      <div class="flex flex-col gap-2">
        <h2>
          {{ spot.officialAnswer ? $t('spotdetail.comments_official_answer_replace') : $t('spotdetail.comments_official_answer_mark')
          }}</h2>
        <p>
          {{ spot.officialAnswer ? $t('spotdetail.comments_official_answer_replace_caution_text') : $t('spotdetail.comments_official_answer_caution_text')
          }}
        </p>
        <p>
          {{ $t('spotdetail.comments_official_answer_notification_text') }}
        </p>
        <ButtonSubmit
          :small="true"
          :title="spot.officialAnswer ? $t('spotdetail.comments_official_answer_replace') : $t('spotdetail.comments_official_answer')"
          @click="markAsOfficialAnswer()"
          :loading="loading"
          :error="error"
        />
      </div>
    </Modal>
  </div>
</template>
<script setup lang="ts">
const { $api } = useNuxtApp()

const loading = ref(false);
const error = ref(false);

const props = defineProps<{ comment: Comment, officialdAnswerId?: Number, spot: SpotDetail }>();


function openModal() {
  const addModal = document.getElementById(
    'add_official_answer_modal-' + props.comment.id
  ) as HTMLFormElement;
  if (addModal) {
    addModal.show();
  }
}

function closeModal() {
  const addModal = document.getElementById(
    'add_official_answer_modal-' + props.comment.id
  ) as HTMLFormElement;
  if (addModal) {
    addModal.close();
  }
}

function markAsOfficialAnswer() {
  loading.value = true;
  error.value = false;
  const url =
    '/spots/' +
    props.spot.id +
    '/comments/' +
    props.comment.id.toString() +
    '/markOfficial';

  $api<Comment>(url)
    .then(function(response) {
      props.spot.officialAnswer = response;
      closeModal();
    })
    .catch(function() {
      error.value = false;
    })
    .finally(() => {
      loading.value = false;
    });
}
</script>
